import { createUseStyles } from 'react-jss';

const styles = {
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1.6rem',
    marginBottom: '9.6rem',
  },
  continueButtonsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.6rem',
  },
  actionButton: {
    padding: 0,
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
